module.exports = __webpack_public_path__ + "img/solution_partner_xmyh@2x.7fd3b737.png";